"use strict";
/**
 *
 * Row/RowHeader
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
// decorate
const decorate_1 = __importDefault(require("./decorate"));
function makeRowHeader(config) {
    const { columns } = config;
    const RowHeader = react_1.default.forwardRef(function RowHeader(props, ref) {
        const { children: _0, classes, className, component: Component = 'div' } = props, rest = __rest(props, ["children", "classes", "className", "component"]);
        const children = react_1.useMemo(() => columns.map(({ width, minWidth, maxWidth, flexGrow, flexShrink, textAlign, style, HeaderCell }, index) => (react_1.default.createElement("div", { key: index.toString(), className: classes.cell, role: "columnheader", style: Object.assign({ width,
                minWidth,
                maxWidth,
                flexGrow,
                flexShrink,
                textAlign }, style) }, typeof HeaderCell === 'function' ? react_1.default.createElement(HeaderCell, Object.assign({}, rest)) : HeaderCell))), [classes, rest]);
        return (react_1.default.createElement(Component, { className: clsx_1.default(classes.root, className), role: "row", ref: ref }, children));
    });
    if (process.env.NODE_ENV !== 'production') {
        RowHeader.displayName = 'RowHeader';
    }
    return react_1.default.memo(decorate_1.default(RowHeader));
}
exports.makeRowHeader = makeRowHeader;
